import type { InboundForwarding, InboundMessage } from 'types/inbound'
import { isSmsSender, type Sender, type SmsSender } from 'types/senders'

export function isInboundDestinationValid(destinationUrl: string, audience: string): boolean {
  if (!/^[a-z][a-z0-9_-]{0,63}$/.test(audience)) {
    return false
  }
  try {
    const url = new URL(destinationUrl)
    return (
      !url.username &&
      !url.password &&
      !url.search &&
      !url.hash &&
      (url.protocol === 'https:' || (url.protocol === 'http:' && url.hostname.endsWith('.svc.cluster.local')))
    )
  } catch {
    return false
  }
}

export function inboundSenderOptions(senders: Sender[], forwardings: InboundForwarding[]): SmsSender[] {
  const configured = new Set(forwardings.map((forwarding) => forwarding.phoneNumber))
  return senders.filter(
    (sender): sender is SmsSender =>
      isSmsSender(sender) &&
      sender.active &&
      sender.verified &&
      !sender.inboundApp &&
      !configured.has(sender.phoneNumber),
  )
}

export function inboundSenderLabel(message: Pick<InboundMessage, 'contact' | 'senderStatus' | 'fromPhone'>): string {
  if (message.senderStatus === 'known' && message.contact) {
    return [message.contact.firstName, message.contact.lastName].filter(Boolean).join(' ') || message.fromPhone
  }
  return message.senderStatus === 'ambiguous' ? 'Unknown sender (multiple contacts)' : 'Unknown sender'
}

export function inboundDeliveryStatus(
  message: Pick<InboundMessage, 'filtered' | 'deliveredAt' | 'terminalAt' | 'attempts'>,
): string {
  if (message.filtered) {
    return 'Filtered'
  }
  if (message.deliveredAt) {
    return 'Delivered'
  }
  if (message.terminalAt) {
    return 'Failed'
  }
  return message.attempts > 0 ? 'Retry scheduled' : 'Pending'
}
